import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import {Link} from 'react-router';
import Image from '../../components/image/image';
import Helmet from 'react-helmet';
import Spinner from '../../components/svg/spinner';
import css from './page.scss';
import metaDesc from '../../utils/meta';

import Share from '../../components/share/share';

import PageContent from './content.js';



import { fetchPage } from '../../actions/page.js';

import connect from '../../utils/connect';

class Page extends Component {

	static propTypes = {};
	constructor(props) {
		super(props);

		this.manchettes = [];

		this.state = {
			waiting: false,
			formErrors: {},
			submitted: false,
		};

		this.metaDesc = '';
	}

	componentWillMount() {
		this.fetchPage = bindActionCreators(fetchPage, this.props.dispatch);

		this.fetchPage(this.props.routeParams.splat);
	}

	componentWillUpdate(nextProps, nextState) {
		if (this.props.routeParams.splat !== nextProps.routeParams.splat) {
			this.fetchPage(nextProps.routeParams.splat);
		}
	}

	componentDidUpdate() {

	}

	render() {

		let page = false;

		if (this.props.page.single) {
			page = this.props.page.single;

			if (page.meta && page.meta.description !== this.metaDesc) {
				metaDesc(page.meta.description);
				this.metaDesc = page.meta.description;
			}
		}

		return (

			page.head && (
			<article className='page'>
				<Helmet title={'The FWA - ' + page.head} />
				{page.hero && (
					<Image className='page__hero' img={page.hero} span='span14' alt='' browser={this.props.browser} />
				)}
				{page.isHall == 1 && (
				<section className='page__description page__description--hof'>
					<div className='page__share'>
						<Share title={page.head} url={window.location.href} browser={this.props.browser} />
					</div>
					<div className='span5 page__description__left page__description__left--hof'>
						<Image img={page.hofImage} span='span14' alt='' browser={this.props.browser} />
					</div>
					<div className='span9 span10-tablet span12-mobile page__description__right page__description__right--hof'>
						<h1 className='page__head'>{page.head}</h1>
						<h2 className='page__description__hof'>Hall of fame</h2>
						<p className='page__excerpt page__excerpt--hof span8 span10-tablet span12-mobile'>{page.excerpt}</p>
					</div>
				</section>
				) || (
					<section className='page__description'>
						<div className='page__share'>
							<Share title={page.head} url={window.location.href} browser={this.props.browser} />
						</div>
						<h1 className='page__head'>{page.head}</h1>
						<p className='page__excerpt span8 span12-mobile'>{page.excerpt}</p>
					</section>
				)}

				{page.content && (
					page.content.map((content, i) => (
						<PageContent browser={this.props.browser} isHof={page.isHall} key={'page-content' + i} content={content} />
					))
				)}
			</article>
			) ||
			<Spinner className='case-single__spinner' size='80px'></Spinner>
		);
	}
}

export default connect(Page);



/** WEBPACK FOOTER **
 ** ./frontend/containers/page/page.js
 **/